class DescriptionExpand extends HTMLElement {
  constructor () {
    super()

    this.shortDesc = this.querySelector(
      '[data-el="product-description.shortDescription"]'
    )
    this.longDesc = this.querySelector(
      '[data-el="product-description.longDescription"]'
    )
    this.trigger = this.querySelector('[data-el="product-description.trigger"]')

    if (!this.longDesc || !this.trigger) {
      return
    }

    this.isOpen = false

    this.setupListeners()
  }

  setupListeners () {
    this.trigger.addEventListener('click', this.handleCLick.bind(this))
  }

  handleCLick () {
    this.isOpen ? this.hideLongDesc() : this.showLongDesc()
  }

  showLongDesc () {
    this.isOpen = true

    // Check full height of long desc
    const fullHeight = this.calcLongDescFullHeight()

    // Prepare styles for height transition
    this.longDesc.style.setProperty(
      'height',
      `${this.shortDesc.offsetHeight}px`
    )
    this.longDesc.style.setProperty('position', 'static')

    this.toggleAriaHidden()
    this.toggleOpacity()
    this.toggleTriggerText()

    // Adjust height to reveal long desc - https://www.justjeb.com/post/why-does-settimeout-work
    window.setTimeout(() => {
      this.longDesc.style.setProperty('height', `${fullHeight}px`)
    }, 0)

    // Wait 0.5s for animation to finish before applying height auto
    window.setTimeout(() => {
      this.longDesc.style.setProperty('height', 'auto')
    }, 500)
  }

  hideLongDesc () {
    this.isOpen = false

    // Give long desc an actual height value
    this.longDesc.style.setProperty('height', `${this.longDesc.offsetHeight}px`)

    // Adjust height to reveal long desc - https://www.justjeb.com/post/why-does-settimeout-work
    window.setTimeout(() => {
      this.longDesc.style.setProperty('height', '0')
    }, 0)

    this.toggleAriaHidden()
    this.toggleOpacity()
    this.toggleTriggerText()
  }

  calcLongDescFullHeight () {
    this.longDesc.style.setProperty('opacity', '0')
    this.longDesc.style.setProperty('position', 'absolute')
    this.longDesc.style.setProperty('height', 'auto')
    return this.longDesc.offsetHeight
  }

  toggleOpacity () {
    this.shortDesc.style.setProperty('opacity', this.isOpen ? 0 : 1)
    this.longDesc.style.setProperty('opacity', this.isOpen ? 1 : 0)
  }

  toggleAriaHidden () {
    if (this.isOpen) {
      this.shortDesc.setAttribute('aria-hidden', 'true')
      this.longDesc.removeAttribute('aria-hidden')
    } else {
      this.shortDesc.removeAttribute('aria-hidden')
      this.longDesc.setAttribute('aria-hidden', 'true')
    }
  }

  toggleTriggerText () {
    this.trigger.innerText = this.isOpen ? 'Read less' : 'Read more'
  }
}

customElements.define('product-description', DescriptionExpand)
